import React, { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext.js";
import { parseSportsHandoffUrl } from "./sportsHandoffUrl.js";
import "./styles/Login.css";

const Login = () => {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const returnToParams = new URLSearchParams(window.location.search);
  const requestedReturnTo = returnToParams.get("returnTo");
  const sportsReturnTo = returnToParams.getAll("returnTo").length === 1
    ? parseSportsHandoffUrl(requestedReturnTo)
    : null;
  const invalidReturnTo = returnToParams.has("returnTo") && !sportsReturnTo;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const resp = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password })
      });

      const data = await resp.json();

      if (!resp.ok) {
        throw new Error(data.message || "Login failed");
      }

      login(data.token);

      if (sportsReturnTo) {
        navigate(sportsReturnTo.path, { replace: true });
        return;
      }

      switch (data.role) {
        case "admin":
          navigate("/admin/dashboard", { replace: true });
          break;
        case "journalist":
          navigate("/journal/home", { replace: true });
          break;
        case "reporter":
          navigate("/report/home", { replace: true });
          break;
        case "user":
          navigate("/user/profile", { replace: true });
          break;
        case "freemium":
          navigate("/", { replace: true });
          break;
        default:
          navigate("/", { replace: true });
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(err.message);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2>Sign In</h2>
        {invalidReturnTo && <div className="login-error" role="alert">This sports sign-in link is invalid. You can still sign in to VyralNews normally.</div>}
        {error && <div className="login-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="login-form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              autoComplete="username"
              required
            />
          </div>
          <div className="login-form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              autoComplete="current-password"
              required
            />
          </div>
          <button type="submit">Sign In</button>
        </form>
        <div className="login-footer">
          <p>Don't have an account? <Link to="/signup">Sign Up</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Login;
